<template>
  <div v-loading="oLoading.detail">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">新增维保信息</template>
      </QS-h3-title>
      <div class="splitline mt16 mb16" />
      <el-form
        class="infor"
        :label-width="labelWidth"
        :model="formLabelAlign"
        ref="maintenance"
        :rules="rules"
        label-position="right"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item :label="'维保类型' + columnSeparator" prop="type">
              <el-select
                placeholder="请选择"
                v-model="formLabelAlign.type"
                clearable
                @change="handleType"
              >
                <el-option
                  v-for="item in maintenanceTypList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="'服务商' + columnSeparator" prop="providerId">
              <el-select
                placeholder="请选择"
                v-model="formLabelAlign.providerId"
                clearable
              >
                <el-option
                  v-for="item in options4"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="'车牌号' + columnSeparator" prop="carId">
              <CarSelect
                :modelValue="formLabelAlign.carId"
                :getCarDetail="true"
                :plateNo="formLabelAlign.plateNo"
                @update:modelValue="val => { formLabelAlign.carId = val }"
                @change="selectBtn">
              </CarSelect>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="'来源类型' + columnSeparator"
              prop="sourceType"
            >
              <span>录入</span>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-for="item in list" :key="item.key">
            <el-form-item :label="item.name + columnSeparator">
              {{ source[item.key] || '--' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="'进厂时间' + columnSeparator"
              prop="incomeTime"
            >
              <el-date-picker
                v-model="formLabelAlign.incomeTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="getCustomerData"
                :picker-options="incomeTimeOption"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :label="'计划出厂时间' + columnSeparator"
              prop="estimateLeaveTime"
            >
              <el-date-picker
                v-model="formLabelAlign.estimateLeaveTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="estimateLeaveTimeOption"
                @change="val => changeLeaveTime(val, 'estimateLeaveTime')"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'出厂时间' + columnSeparator"
              prop="leaveTime"
            >
              <el-date-picker
                v-model="formLabelAlign.leaveTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="leaveTimeOption"
                @change="val => changeLeaveTime(val, 'leaveTime')"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'维保总费用' + columnSeparator"
              prop="totalAmount"
            >
              <el-input
                v-model="formLabelAlign.totalAmount"
                :disabled="totalDisabled"
                maxlength="18"
                v-limit-money="true"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'客户承担维保金额' + columnSeparator"
              prop="customerAmount"
            >
              <el-input
                :disabled="totalDisabled"
                v-model="formLabelAlign.customerAmount"
                maxlength="18"
                v-limit-money="true"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="'维保状态' + columnSeparator"
              prop="maintenanceState"
            >
              <el-select
                placeholder="请选择"
                v-model="formLabelAlign.maintenanceState"
                clearable
              >
                <el-option
                  v-for="item in maintenanceStateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'结算状态' + columnSeparator"
              prop="settlementState"
            >
              <el-select
                placeholder="请选择"
                v-model="formLabelAlign.settlementState"
                clearable
              >
                <el-option
                  v-for="item in settlementStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :label="'进厂公里数' + columnSeparator"
              prop="incomeKm"
            >
              <el-input
                v-model="formLabelAlign.incomeKm"
                placeholder="请输入"
                v-number:km
              >
                <template slot="append">公里</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="formLabelAlign.type === 2">
            <el-form-item
              :label="'上次保养里程' + columnSeparator"
              prop="lastMaintenanceKm"
            >
              <el-input
                v-model="formLabelAlign.lastMaintenanceKm"
                placeholder="请输入"
                v-number:km
              >
                <template slot="append">公里</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="formLabelAlign.type === 2">
            <el-form-item
              :label="'超保里程' + columnSeparator"
              prop="overMaintenanceKm"
            >
              <el-input
                v-model="formLabelAlign.overMaintenanceKm"
                placeholder="请输入"
                v-number:km
              >
                <template slot="append">公里</template>
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label="'处理备注' + columnSeparator"
              class="alone"
              prop="remarks"
            >
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入"
                v-model="formLabelAlign.remarks"
                maxlength="500"
                show-word-limit
                @input="changeRemarks"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="'送修原因' + columnSeparator"
              class="alone"
              prop="reasonForRepair"
            >
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入"
                v-model.trim="formLabelAlign.reasonForRepair"
                maxlength="500"
                show-word-limit
                @input="changeReasonForRepair"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="specail_upload"
              :label="'结算单附件' + columnSeparator"
            >
              <UploadCommon
                :fileList="fileList"
                listType="text"
                :limit="20"
                :sizeType="4"
                commonUpload
                group="assert"
                code="assert_settlement_list"
                multiple
              ></UploadCommon>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <addPhoto ref="addPhoto" :type="formLabelAlign.type" />
      <AddPay
        ref="addPay"
        :addPayList="addPayList"
        @countAllPay="changeAllPay"
        :countAllPay="formLabelAlign.totalAmount"
        :type="formLabelAlign.type"
        @totalDisabled="val => (this.totalDisabled = val)"
      />
      <!-- 司机警示金 -->
      <editDriverWarningPay
        v-if="formLabelAlign.type"
        :type="formLabelAlign.type"
        :driverWarningPayData="driverWarningPayData"
      />
      <!-- 确定/取消按钮 -->
      <template slot="bottomAction">
        <div>
          <el-button @click="goPageBack" size="small">取消</el-button>
          <el-button
            type="primary"
            @click="submitBtn"
            size="small"
            :loading="oLoading.submit"
            >确认新增</el-button
          >
        </div>
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import {
  getOrderOnTime,
  maintenanceAdd,
  queryByType,
} from '@/api/domain/carsService'
import { providerList } from '@/api/domain/organize'
import selectOption from '@/store/dict/selectOptionDict'
import { parseTime } from '@/utils'
import moment from 'moment'
import AddPay from '../components/addPay.vue'
import addPhoto from '../components/addPhoto.vue'
import editDriverWarningPay from '../components/editDriverWarningPay.vue'

export default {
  components: {
    AddPay,
    editDriverWarningPay,
    addPhoto,
  },
  data() {
    return {
      oLoading: {
        detail: false,
        submit: false,
      },
      list: [
        {
          key: 'brandName',
          name: '品牌',
        },
        {
          key: 'seriesName',
          name: '车系',
        },
        {
          key: 'carModelName',
          name: '车型',
        },
        {
          key: 'carId',
          name: '车辆ID',
        },
        {
          key: 'customerName',
          name: '当前客户',
        },
        {
          key: 'customerId',
          name: '客户ID',
        },
        {
          key: 'contractId',
          name: '订单ID',
        },
      ],
      labelWidth: '130px',
      source: {
        brandName: '',
        seriesName: '',
        carModelName: '',
        carId: '',
        contractId: '',
        customerName: '',
        customerId: '',
      },
      /* 上传假数据 */
      fileList: [],
      formLabelAlign: {
        carId: '',
        plateNo: '',
        type: '',
        providerId: '',
        incomeTime: '',
        incomeKm: '',
        totalAmount: '',
        customerAmount: '',
        leaveTime: '',
        maintenanceState: '',
        settlementState: '',
        remarks: '',
        attachment: '',
        reasonForRepair: '',
        expenseBearingParty: '',
        estimateLeaveTime: '',
        lastMaintenanceKm: '',
        overMaintenanceKm: '',
      },
      // 司机警示金
      driverWarningPayData: {
        exceedAmount: '',
        floatAmount: '',
        depreciationAmount: '',
      },
      options4: [],
      rules: {
        carId: [
          { required: true, message: '车牌号不能为空', trigger: 'change' },
        ],
        type: [
          { required: true, message: '维保类型不能为空', trigger: 'change' },
        ],
        providerId: [
          { required: true, message: '不能为空', trigger: 'change' },
        ],
        incomeTime: [
          {
            required: true,
            message: '进厂时间不能为空',
            trigger: 'blur',
          },
        ],
        incomeKm: [
          { required: true, message: '进厂公里数不能为空', trigger: 'blur' },
        ],

        maintenanceState: [
          { required: true, message: '维保状态不能为空', trigger: 'change' },
        ],
        settlementState: [
          { required: true, message: '结算状态不能为空', trigger: 'change' },
        ],
        remarks: [
          { required: false, message: '备注不能为空', trigger: 'blur' },
        ],
        expenseBearingParty: [
          { required: true, message: '费用承担方不能为空', trigger: 'change' },
        ],
      },
      addPayList: [],
      totalDisabled: true,
    }
  },
  mounted() {
    if (this.$route.query.plateNo !== undefined) {
      this.formLabelAlign.plateNo = this.$route.query.plateNo
    }
    if (this.$route.query.type !== undefined) {
      this.formLabelAlign.type = Number(this.$route.query.type)
    }

    this.getProvider()
  },
  methods: {
    // 车牌号+进场时间获取最新客户订单信息
    getCustomerData(val) {
      if (val) {
        const inputTime = moment(val)
        if (
          inputTime.isSameOrAfter(
            moment(this.formLabelAlign.estimateLeaveTime),
          ) ||
          inputTime.isSameOrAfter(moment(this.formLabelAlign.leaveTime))
        ) {
          this.formLabelAlign.incomeTime = ''
          this.$message.warning('进厂时间需要早于出厂时间和计划出厂时间')
        }
      }
      const { carId } = this.source
      const { incomeTime } = this.formLabelAlign
      if (carId && incomeTime) {
        getOrderOnTime({
          time: incomeTime,
          carId,
        }).then((res) => {
          const { data } = res
          if (!data) return
          const { customerId, orderId, customerName, brandName, seriesName } = data
          this.source.customerId = customerId || ''
          this.source.contractId = orderId || ''
          this.source.customerName = customerName || ''
          this.source.brandName = brandName || ''
          this.source.seriesName = seriesName || ''
        })
      }
    },

    async getProvider() {
      const { data } = await providerList({
        serviceType: 1,
        state: 1,
      })
      this.options4 = data ? data.items : []
    },
    /* 车牌号关联搜索 */
    selectBtn(id, carInfo) {
      this.source.carId = id
      this.source.carModelName = carInfo?.modelName || ''
      this.source.brandName = carInfo?.brandName || ''
      this.source.seriesName = carInfo?.seriesName || ''
      this.formLabelAlign.plateNo = carInfo?.plateNo || ''
      this.getCustomerData()
    },

    /*  确认新增 */
    async submitBtn() {
      let status = false
      this.formLabelAlign.attachment = this.getUoloadCommonFileData(
        this.fileList,
      )
      const tempDriverWarningPayData = this.driverWarningPayData
      Object.keys(tempDriverWarningPayData).forEach((key) => {
        if (!tempDriverWarningPayData[key]) { tempDriverWarningPayData[key] = '0.00' }
      })
      this.formLabelAlign = {
        ...this.formLabelAlign,
        ...this.source,
        photo: this.imageFilter(),
        ...tempDriverWarningPayData,
      }
      const payParam = this.$refs.addPay.handleValidate()
      this.$refs.maintenance.validate((valid) => {
        status = valid
      })
      if (status && payParam) {
        this.formLabelAlign.itemsList = payParam
        // 开启按钮loading
        this.oLoading.submit = true
        try {
          const data = await maintenanceAdd(this.formLabelAlign)
          this.oLoading.submit = false
          if (data.code === 1) {
            this.btnloding = false
            this.$message.success('操作成功')
            this.$refreshBack(true) // 关闭当天tab
            this.$router.push({
              path: '/vehicle/maintenance/list',
            })
          }
        } catch (error) {
          this.oLoading.submit = false
        }
      } else {
        this.$message.error(
          payParam ? '请填写带有红色 * 的必填项' : '请完善维保添加项目',
        )
      }
    },
    /* 返回页面上一级 */
    goPageBack() {
      this.$refreshBack(true)
    },
    async handleType(type) {
      this.addPayList = []
      if (!type) return
      try {
        const { code, data } = await queryByType({ type })
        if (code === 1 && Array.isArray(data) && data.length) {
          this.addPayList = data
        }
      } catch (error) {
        console.warn('维保项目抱错接口', error)
      }
    },
    changeAllPay({ customerMaintenanceAmountTotal, resStove }) {
      // 维保总费用
      if (this.formLabelAlign.totalAmount !== resStove) {
        this.formLabelAlign.totalAmount = resStove
      }
      // 客户承担维保金额
      if (
        this.formLabelAlign.customerAmount !== customerMaintenanceAmountTotal
      ) {
        this.formLabelAlign.customerAmount = customerMaintenanceAmountTotal
      }
    },
    // 处理备注
    changeRemarks(val) {
      if (val) {
        // eslint-disable-next-line no-misleading-character-class, no-useless-escape
        const regStr = /([0-9|*|#]\uFE0F\u20E3)|([0-9|#]\u20E3)|([\u203C-\u3299]\uFE0F\u200D)|([\u203C-\u3299]\uFE0F)|([\u2122-\u2B55])|(\u303D)|([(\A9)|(\AE)]\u3030)|(\uA9)|(\uAE)|(\u3030)|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF])|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F])/g
        if (regStr.test(val)) {
          const str = val.replace(regStr, '')
          // val = str
          this.$set(this.formLabelAlign, 'remarks', str)
        }
      }
    },
    // 送修原因
    changeReasonForRepair(val) {
      if (val) {
        // eslint-disable-next-line no-misleading-character-class, no-useless-escape
        const regStr = /([0-9|*|#]\uFE0F\u20E3)|([0-9|#]\u20E3)|([\u203C-\u3299]\uFE0F\u200D)|([\u203C-\u3299]\uFE0F)|([\u2122-\u2B55])|(\u303D)|([(\A9)|(\AE)]\u3030)|(\uA9)|(\uAE)|(\u3030)|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF])|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F])/g
        if (regStr.test(val)) {
          const str = val.replace(regStr, '')
          // val = str
          this.$set(this.formLabelAlign, 'reasonForRepair', str)
        }
      }
    },
    // 计划出厂时间、出厂时间变更
    changeLeaveTime(val, key) {
      if (val && moment(val).isSameOrBefore(moment(this.formLabelAlign.incomeTime))) {
        this.formLabelAlign[key] = ''
        const keyName = key === 'leaveTime' ? '出厂时间' : '计划出厂时间'
        this.$message.warning(`${keyName}需要晚于进厂时间`)
      }
    },
    // 图片处理
    imageFilter() {
      const obj = { ...this.$refs.addPhoto.form }
      for (const key in obj) {
        obj[key] = this.getUoloadCommonFileData(obj[key], false)
      }
      return JSON.stringify(obj)
    },
  },
  computed: {
    // 维保类型
    maintenanceTypList() {
      return this.dictParseList(selectOption.maintenanceTypeDict)
    },
    // 维保状态
    maintenanceStateList() {
      return this.dictParseList(selectOption.maintenanceStateDict).filter((item) => item.value !== 5)
    },
    // 结算状态
    settlementStatusList() {
      return this.dictParseList(selectOption.settlementStatusDict)
    },
    // // 费用承担方
    // expenseBearingPartyList() {
    //   return this.dictParseList(selectOption.costBearingParty)
    // },
    //  出厂时间选择
    leaveTimeOption() {
      // 出厂时间 >= 进厂时间
      let result = this.formLabelAlign.incomeTime
      result = result && result.split(' ')[0]
      return {
        disabledDate: (time) => {
          if (!result) return false
          time = parseTime(time.getTime(), '{y}-{m}-{d}')
          return time < result
        },
      }
    },
    // 计划出厂时间选择
    estimateLeaveTimeOption() {
      let result = this.formLabelAlign.incomeTime
      result = result && result.split(' ')[0]
      return {
        disabledDate: (time) => {
          if (!result) return false
          time = parseTime(time.getTime(), '{y}-{m}-{d}')
          return time < result
        },
      }
    },
    // 进厂时间
    incomeTimeOption() {
      const leaveTime = new Date(this.formLabelAlign.leaveTime).getTime() // 出厂时间
      const estimateLeaveTime = new Date(this.formLabelAlign.estimateLeaveTime).getTime()// 计划出厂时间
      let result = null
      if (leaveTime && estimateLeaveTime) {
        if (leaveTime > estimateLeaveTime) result = estimateLeaveTime
        else if (leaveTime < estimateLeaveTime) result = leaveTime
        else result = leaveTime || estimateLeaveTime
      } else if (leaveTime) result = leaveTime
      else if (estimateLeaveTime) result = estimateLeaveTime
      else result = 0
      return {
        disabledDate: (time) => {
          if (!this.formLabelAlign.leaveTime && !this.formLabelAlign.estimateLeaveTime) return false
          time = time.getTime()
          return Number(time) > Number(result)
        },
      }
    },
  },
}
</script>

<style lang="less" scoped>
.content1 {
  margin-bottom: 24px;
}
.infor {
  ::v-deep .el-input--small {
    max-width: 190px;
  }
  .columnBox {
    ::v-deep .column_content_mrbtm {
      align-items: center;
    }
  }
}
.specail_upload {
  ::v-deep .el-form-item__content {
    // margin-left: 140px !important;
    // margin-top: -30px;
  }
  ::v-deep .upload-box.textType {
    width: 222px !important;
  }
  ::v-deep .el-upload {
    width: 220px !important;
  }
  ::v-deep .el-upload-dragger {
    width: 220px !important;
  }
  ::v-deep .upload-box .textType-box .filelist-ul ._info .txt {
    width: 100px;
  }
}
</style>
